"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var useTimeout = function (duration, callback) {
    var _a = react_1["default"].useState(false), isActive = _a[0], setIsActive = _a[1];
    var start = react_1["default"].useCallback(function () {
        setIsActive(true);
    }, []);
    var stop = react_1["default"].useCallback(function () {
        setIsActive(false);
    }, []);
    react_1["default"].useEffect(function () {
        var timeout;
        if (isActive) {
            timeout = setTimeout(function () {
                callback();
                stop();
            }, duration * 1000);
        }
        else {
            clearTimeout(timeout);
        }
        return function () { return clearTimeout(timeout); };
    }, [isActive, callback, duration, stop]);
    return [start, stop, isActive];
};
exports["default"] = useTimeout;
